import { useEffect } from 'react';
import Button from './common/Button';

const { Kakao } = window;

const KakaoShare = () => {
  useEffect(() => {
    Kakao.cleanup();
    Kakao.init(process.env.REACT_APP_KAKAO_APP_KEY);
    console.log(Kakao.isInitialized());
  }, []);

  const shareKakao = () => {
    Kakao.Share.sendCustom({
      templateId: 117756,
      templateArgs: {
        title: '홍영준 🖤 오유진 결혼합니다',
        description: '2025년 6월 1일 오전 11시 제주 퍼시픽 호텔',
      },
    });
  };

  return (
    <Button
      onClick={() => {
        shareKakao();
      }}
    >
      카카오톡 공유하기
    </Button>
  );
};

export default KakaoShare;
